import { render, staticRenderFns } from "./PlanningPhaseItem.vue?vue&type=template&id=4371a85f&"
import script from "./PlanningPhaseItem.vue?vue&type=script&lang=js&"
export * from "./PlanningPhaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports